import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";
import { useParams } from "react-router";

const UpdateFileDataLibrary = ({ Show, Hide, Title, getEditorProjectData, projectData }) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [title, setTitle] = useState([]);
  const [description, setDescription] = useState([]);
  const [error, setError] = useState("");
  const { studyId } = useParams()

  function replaceLastSegment(path, newSegment) {
    const parts = path.split('/');
    parts[parts.length - 1] = newSegment;
    return parts.join('/');
  }

  const updateProjectData = async () => {
    setButtonLoader(true)
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Change Title of this File?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, change it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        let data
        if (projectData?.keepFile !== "system") {
          userData.id = projectData?._id;
          userData.studyId = studyId;
          userData.name = title;
          userData.description = description;
          if(projectData?.type === "folder"){
            userData.previousName = `${projectData?.path}/`;
            userData.currentName = `${replaceLastSegment(projectData?.path, title)}/`;
          }else{
            userData.previousName = `${projectData?.path}.csv`;
            userData.currentName = `${replaceLastSegment(projectData?.path, title)}.csv/`;
          }
          data = await editorProjectServices.updateProjectData(
            userData
          );
        } else {
          userData.oldName = `${projectData?.name}${projectData?.oldExtension}`;
          userData.newName = `${title}${projectData?.oldExtension}`;
          userData.folderPath = `${projectData?.localPath}`;
          data = await editorProjectServices.renameLocalFile(
            userData
          );
        }
        setButtonLoader(false)
        if (data?.statusCode === 200) {
          getEditorProjectData();
          setTitle("")
          setDescription("")
          setError("")
          Hide()
        }
      }
    });
  };

  const validateFileTitle = (input) => {
    const fileTitleRegex = /^[a-zA-Z0-9_]+$/;

    if (!fileTitleRegex.test(input)) {
      setError(
        "File Title should only contain capital letters, small letters, or numbers"
      );
    } else {
      setError("");
    }
  };

  useEffect(() => {
    setTitle(projectData?.name);
    setDescription(projectData?.description);
  }, [projectData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Title{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                validateFileTitle(e.target.value);
              }}
              placeholder="Enter File Title"
              required
            />
            {error && (
              <span style={{ fontSize: 10, color: "red", fontWeight: 600 }}>
                File Title should only contain capital letters, small letters,
                underScore, and numbers "Space Not Allowed"
              </span>
            )}
          </Form.Group>
          {projectData?.keepFile !== "system" &&
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Description{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Enter File Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
              />
            </Form.Group>
          }
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            // disabled={
            //   projectData?.keepFile !== "system" ?
            //     (buttonLoader || !title || !description)
            //     :
            //     (buttonLoader || !title)
            // }
            title={Title}
            className="updateProfile"
            onClick={() => {
              updateProjectData();
            }}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateFileDataLibrary;
